import { Form as InertiaForm } from '@inertiajs/react'
import { type ComponentProps } from 'react'

import type { AgentOptionType, DeviceOptionType, EmptyCollectSessionFormType } from './types'

type FormProps = Omit<ComponentProps<typeof InertiaForm>, 'children'> & {
  collect_session: EmptyCollectSessionFormType
  agents?: AgentOptionType[]
  devices?: DeviceOptionType[]
  submitText: string
  mode?: 'new' | 'edit'
}

const statusOptions = ['open', 'closed', 'reconciled'] as const

function deviceOptionLabel(device: DeviceOptionType): string {
  const name = device.name || device.code
  const details = [
    device.code && device.code !== name ? device.code : null,
    device.assigned_agent_name ? `Agent: ${device.assigned_agent_name}` : 'Agent: Non assigné',
    device.status,
  ].filter(Boolean)

  return `${name} (${details.join(' - ')})`
}

export default function Form({ collect_session, agents = [], devices = [], submitText, mode = 'edit', ...formProps }: FormProps) {
  // const [startAt, setStartAt] = useState(collect_session.start_at || '')
  // const [endAt, setEndAt] = useState(collect_session.end_at || '')
  // const startAtRef = useRef<HTMLInputElement | null>(null)
  // const endAtRef = useRef<HTMLInputElement | null>(null)

  return (
    <InertiaForm
      transform={data => ({ collect_session: data })}
      className="contents"
      {...formProps}
    >
      {({ errors, processing }) => (
        <>
          <div className="my-5">
            <label htmlFor="user_id">Agent</label>
            <select
              name="user_id"
              id="user_id"
              defaultValue={collect_session.user_id || ''}
              className="block shadow rounded-md border border-gray-400 outline-none px-3 py-2 mt-2 w-full"
              required
            >
              <option value="" disabled>Sélectionner un agent</option>
              {agents.map((agent) => (
                <option key={agent.id} value={agent.id}>
                  {agent.name} ({agent.email})
                </option>
              ))}
            </select>
            {errors.user_id && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.user_id.join(', ')}
              </div>
            )}
          </div>

          <div className="my-5">
            <label htmlFor="device_id">Terminal</label>
            <select
              name="device_id"
              id="device_id"
              defaultValue={collect_session.device_id || ''}
              className="block shadow rounded-md border border-gray-400 outline-none px-3 py-2 mt-2 w-full"
              required
            >
              <option value="" disabled>Sélectionner un terminal</option>
              {devices.map((device) => (
                <option key={device.id} value={device.id}>
                  {deviceOptionLabel(device)}
                </option>
              ))}
            </select>
            {errors.device_id && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.device_id.join(', ')}
              </div>
            )}
          </div>

          {/*<div className="my-5">*/}
          {/*  <label htmlFor="start_at">Start at</label>*/}
          {/*  <div className="mt-2 flex items-center gap-2">*/}
          {/*    <input*/}
          {/*      ref={startAtRef}*/}
          {/*      type="datetime-local"*/}
          {/*      name="start_at"*/}
          {/*      id="start_at"*/}
          {/*      value={startAt}*/}
          {/*      onChange={(e) => setStartAt(e.target.value)}*/}
          {/*      className="block w-full shadow rounded-md border border-gray-400 outline-none px-3 py-2"*/}
          {/*    />*/}
          {/*    <Button*/}
          {/*      type="button"*/}
          {/*      variant="outline"*/}
          {/*      onClick={() => {*/}
          {/*        const input = startAtRef.current as (HTMLInputElement & { showPicker?: () => void }) | null*/}
          {/*        input?.showPicker?.()*/}
          {/*        input?.focus()*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      <Calendar className="h-4 w-4" />*/}
          {/*    </Button>*/}
          {/*  </div>*/}
          {/*  {errors.start_at && (*/}
          {/*    <div className="text-red-500 px-3 py-2 font-medium">*/}
          {/*      {errors.start_at.join(', ')}*/}
          {/*    </div>*/}
          {/*  )}*/}
          {/*</div>*/}

          {/*<div className="my-5">*/}
          {/*  <label htmlFor="end_at">End at</label>*/}
          {/*  <div className="mt-2 flex items-center gap-2">*/}
          {/*    <input*/}
          {/*      ref={endAtRef}*/}
          {/*      type="datetime-local"*/}
          {/*      name="end_at"*/}
          {/*      id="end_at"*/}
          {/*      value={endAt}*/}
          {/*      onChange={(e) => setEndAt(e.target.value)}*/}
          {/*      className="block w-full shadow rounded-md border border-gray-400 outline-none px-3 py-2"*/}
          {/*    />*/}
          {/*    <Button*/}
          {/*      type="button"*/}
          {/*      variant="outline"*/}
          {/*      onClick={() => {*/}
          {/*        const input = endAtRef.current as (HTMLInputElement & { showPicker?: () => void }) | null*/}
          {/*        input?.showPicker?.()*/}
          {/*        input?.focus()*/}
          {/*      }}*/}
          {/*    >*/}
          {/*      <Calendar className="h-4 w-4" />*/}
          {/*    </Button>*/}
          {/*  </div>*/}
          {/*  {errors.end_at && (*/}
          {/*    <div className="text-red-500 px-3 py-2 font-medium">*/}
          {/*      {errors.end_at.join(', ')}*/}
          {/*    </div>*/}
          {/*  )}*/}
          {/*</div>*/}

          {mode === 'edit' && (
            <div className="my-5">
              <label htmlFor="physical_amount_collected">Montant physique collecté</label>
              <input
                type="number"
                name="physical_amount_collected"
                id="physical_amount_collected"
                defaultValue={collect_session.physical_amount_collected}
                className="block shadow rounded-md border border-gray-400 outline-none px-3 py-2 mt-2 w-full"
              />
              {errors.physical_amount_collected && (
                <div className="text-red-500 px-3 py-2 font-medium">
                  {errors.physical_amount_collected.join(', ')}
                </div>
              )}
            </div>
          )}

          <div className="my-5">
            <label htmlFor="status">Statut</label>
            <select
              name="status"
              id="status"
              defaultValue={collect_session.status}
              className="block shadow rounded-md border border-gray-400 outline-none px-3 py-2 mt-2 w-full"
              required
            >
              <option value="" disabled>Sélectionner un statut</option>
              {statusOptions.map((status) => (
                <option key={status} value={status}>
                  {status === 'open' ? 'Ouvert' : status === 'closed' ? 'Fermé' : 'Rapproché'}
                </option>
              ))}
            </select>
            {errors.status && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.status.join(', ')}
              </div>
            )}
          </div>

          <div className="inline">
            <button
              type="submit"
              disabled={processing}
              className="rounded-lg py-3 px-5 bg-blue-600 text-white inline-block font-medium cursor-pointer"
            >
              {submitText}
            </button>
          </div>
        </>
      )}
    </InertiaForm>
  )
}
